// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { TenantFromJSON, } from '../models';
/**
 * get user settings
 * get user settings
 */
export function getUserSettingsRaw(requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/settings` + queryString,
        meta,
        update: requestConfig.update || {
            UserSettings: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = TenantFromJSON(body);
            if (body.id) {
                return { UserSettings: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { UserSettings: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `GetUserSettings`;
    return config;
}
/**
* get user settings
* get user settings
*/
export function getUserSettings(requestConfig) {
    return getUserSettingsRaw(requestConfig);
}
